import { render, staticRenderFns } from "./ProductionStats.vue?vue&type=template&id=96905f4e&"
import script from "./ProductionStats.vue?vue&type=script&lang=js&"
export * from "./ProductionStats.vue?vue&type=script&lang=js&"
import style0 from "./ProductionStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports